<template>
  <div class="sku-wrapper">
    <div class="image-box">
      <Images
        :images="detail.imageUrls"
        :video-url="detail.dashVideoUrl || detail.videoUrl"
        :current-sku-img="currentSelectedSku?.images[0] || ''"
        :imgTitle="detail.title"
      />
    </div>
    <div class="content-box">
      <!-- <div class="product-title">{{ detail.title }}</div> -->
      <h1 class="product-title">{{ detail.title }}</h1>

      <p class="warning-tips" v-for="(tips, idx) in warningTipsText" :key="idx">{{ tips }}</p>

      <div class="score-and-reviews">
        <van-rate :model-value="Number(reviewScore || '5')" size="16" />
        <span class="rate">{{ reviewScore || '5.0' }}</span>
        <a href="#pc__product-detail__reviews">
          <span class="reviews" @click="handleSwitchReviewTabClick">{{ reviewTotal }} Customer reviews</span>
        </a>
      </div>
      
      <div
        v-if="skuActivateInfo && [1, 4, 6].includes(skuActivateInfo?.activityType)"
        class="activate-card"
      >
        <ActivateCountdownCard
          :key="activityKey(skuActivateInfo)"
          :options="{
            queryTime: skuActivateInfo.queryTime,
            endTime: skuActivateInfo.endTime,
            activityPrice: skuActivateInfo.activityPrice,
            listPrice: skuPrice.listPrice,
            startTime: skuActivateInfo.startTime
          }"
          :activityInfo="skuActivateInfo"
          @countdown:over="handleCountdownOver"
        />
      </div>

      <div class="product-price" v-else>
        <span class="sale-price">
          {{ $currencySymbol() }}
          {{ $toThousandsFn(skuPrice.salePrice) }}
        </span>

        <span class="del-price" v-if="skuPrice.salePrice !== skuPrice.listPrice">
          {{ $currencySymbol() }} {{  $toThousandsFn(skuPrice.listPrice) }}
          <ClientOnly><span v-if="skuPrice.discount > 0 && skuPrice.discount < 100" class="discount">(-{{ skuPrice.discount }}%)</span></ClientOnly>
        </span>
      </div>

      <KilimallChoice v-if="showKilimallChoice" platform="pc" />

      
      <p v-if="detail.prepayment?.state !== -1" class="prepaid-tips">
        <span>{{ `This product supports ${NP.times(detail.prepayment.prepaymentRatio, 100).toFixed(2)}% prepaid.` }}</span>
      </p>

      <!-- 促销 / 包邮 信息 -->
      <div class="promotions-box">
        <!-- 秒杀不参与跨店满减 -->
        <template v-if="skuActivateInfo?.activityType !== 1">
          <div
            v-for="(item, idx) in promotionInfo.bigPromotion"
            :key="idx"
            class="big-promotion promotion-item"
            @click=handleBigPromotionClick(item)
          >
            {{ item.title }} <van-icon name="arrow" />
          </div>
        </template>
        <div
          v-if="promotionInfo.freeShippingPromotion?.name"
          class="ship-promotion promotion-item"
          @click="handleFreeShippingPromotionClick(promotionInfo.freeShippingPromotion)"
        >
          {{ promotionInfo.freeShippingPromotion.name }} <van-icon name="arrow" />
        </div>
      </div>
      <div class="buyer-infos">
        <div class="info-item info-item-center" v-if="supportedServices.length > 0">
          <div class="label">Services:</div>
          <div class="value">
            <span v-for="(item, idx) in supportedServices" :key="idx" class="services-item">
              <van-icon size="16" name="passed" color="#DD3131" />{{ item }}
            </span>
          </div>
        </div>
      
        <div class="info-item" v-if="gifts.length > 0">
          <div class="label info-item-gift">Have Gift:</div>
          <div class="value">
            <KGiftsCard :gifts="gifts" />
          </div>
        </div>
       
        <div
          v-for="(item, idx) in detail.specs"
          :key="idx"
          class="info-item"
        >
          <div class="label info-item-spec">
            {{ item.name }}:
            <span
              v-if="item.name?.toLocaleLowerCase().indexOf('size') >= 0 && detail.sizeChartPicture"
              class="size-guide"
              @click="handleSizeGuideClick(detail.sizeChartPicture)"
            >
              Size Guide
              <van-icon name="arrow" />
            </span>
          </div>
          <div class="value">
            <div
              v-for="(specValue, specIdx) in item.values"
              :key="`${idx}_${specIdx}`"
              class="spec-btn-box"
              v-show="!specValue.disabledRemoved"
            >
              <div
                class="sku-btn"
                :select="specSelectIndexs[idx] === `${idx}_${specIdx}` ? '1' : '0'"
                @click="handleSkuBtnClick(idx, specIdx)"
              >
                <div class="sku-img-box">
                  <img v-if="specValue.image" :src="$cvWebpFn(specValue.image, { w: 80, removeTag: true })" class="sku-img" :lazy="useImgLazy().value" />
                </div>
                {{ specValue.value }}
              </div>

              <ClientOnly>
                <div v-if="specValue.disabled || specValue.temporaryDisabled" class="sold-out-mark">Sold out</div>
              </ClientOnly>
            </div>
          </div>
        </div>
      
        <div v-if="deliveryInfo" class="info-item info-item-center">
          <div class="label">Delivery Information:</div>
          <div class="value">
            <KProductDeliveryCard :delivery="deliveryInfo" />
          </div>
        </div>
        
        <div v-if="gensVoucherList && gensVoucherList.length && !skuActivateInfo?.flashSale?.noVoucher" class="info-item info-item-center">
          <div class="label">Promotions:</div>
          <div class="value">
            <div class="voucher-div">
              <div v-for="item in gensVoucherList.slice(0,5)" class="voucher-item">
                {{ $currencySymbol() }} {{ item.amount }}
              </div>
              <SearchOperationContainer>
                <template #title>
                  <div class="claim-now">
                    Claim Now
                    <van-icon name="arrow-down" />
                  </div>
                </template>
                <div class="voucher-prop-div">
                  <PCVoucherList
                    :voucherList="gensVoucherList"
                    receive-scene="PRODUCT_DETAIL"
                    @voucher:check="getVoucherFn"
                  />
                </div>
              </SearchOperationContainer>
            </div>
          </div>
        </div>
      
        <div class="info-item info-item-center">
          <div class="label">Quantity</div>
          <div class="value">
            <ClientOnly>
              <VanStepper
                :model-value="quantity"
                @update:model-value="handleQuantityChange"
                :before-change="handleBeforeQuantityChange"
                @overlimit="handleQuantityOverlimit"
                integer
                :max="stepperMaxVal"
                :disabled="maxQuantity <= 0"
              />
              <template #fallback>
                <VanStepper :model-value="1" />
              </template>
            </ClientOnly>
          </div>
        </div>
        
        <div class="opt-button-bar info-item">
          <van-button 
            v-if="showArrivalReminderBtn"
            :class="currentSelectedSku?.isArrivalReminder ? 'opt-btn yellow-btn disabled-opt-btn' : 'opt-btn yellow-btn'"
            style="width: 360px"
            @click="handleArrivalReminderClick"
            type="primary"
          >
            {{ currentSelectedSku?.isArrivalReminder ? 'Cancel Reminder' : 'Arrival Reminder' }}
          </van-button>
          <template v-else>
            <van-button
              :class="buyNowStatus.disabledAddcart ? 'opt-btn yellow-btn disabled-opt-btn' : 'opt-btn yellow-btn'"
              :disabled="buyNowStatus.disabledAddcart"
              @click="handleAddCartClick"
            >Add to Cart</van-button>
            <van-button 
              :disabled="buyNowStatus.disabledBuynow"
              :class="buyNowStatus.disabledBuynow ? 'opt-btn red-btn disabled-opt-btn' : 'opt-btn red-btn'"
              @click="handleByNowClick"
              type="primary"
            >
              {{ buyNowStatus.btnText }}
            </van-button>
          </template>
          
          <van-button class="collect-btn" @click="handleWishClick">
            <van-icon name="like-o" size="24" v-if="!inWishList" />
            <van-icon name="like" size="24" color="#DD3131" v-else />
          </van-button>
          <van-button class="collect-btn" @click="handleShareClick">
            <van-icon name="share-o" size="24" />
          </van-button>
        </div>

        <van-button v-if="inventoryStatus === 'error'" @click="emits('retry:inventory')">Unable to refresh stock. Retry</van-button>
        <p class="btn-tips" v-show="buyNowStatus.btnTips">
          <van-icon name="info-o" />&nbsp;{{ buyNowStatus.btnTips }}
        </p>
      </div>
    </div>

    <van-popup
      v-model:show="showSizePictureVisible"
      position="center"
      closeable
    >
      <div class="size-chart-picture" @wheel="handleWheelChange">
        <img
          v-lazy="$cvWebpFn(detail.sizeChartPicture || '')"
          alt=""
          :style="{ transform: `scale(${scaleSizePicture})` }"
        >
      </div>
    </van-popup>

    <KSShareStoreSharePopup v-model:show="sharePopupShow" @share:click="handleShareItemClick">
      <div class="share-title">Share</div>
      <div class="share-product-card">
        <img v-lazy="detail.imageUrls[0]" alt="" class="product-image" />

        <p class="product-name">{{ detail.title }}</p>
      </div>
    </KSShareStoreSharePopup>
  </div>
</template>

<script setup lang="ts">
import { purchaseActions, activityKey, preserveOriginalAttribution, type InventoryStatus } from '../purchase'
import Images from './Images.vue'
import NP from 'number-precision'
import { showToast } from 'vant'
import {
  addCartItem,
  delWishListing,
  getVouchersBySkuids,
  wishListing,
  putSubscription,
  type ISubscriptionParams,
  type IVoucherParmas,
  type ISkuItemParams
} from '@/api/models/product'
import { getShareLink, type IShareLinkType } from '@/api/models/share'
import { buildShareLinkTrafficSourceParams } from '@/plugins/utils'
import { type IGifts } from '@/components/KGifts/Card.vue'
import { getShipingCartTotal, type Voucher } from '@/api/models/userInfo'
import ActivateCountdownCard from './ActivateCountdownCard.vue'
import KilimallChoice from '../widgets/KilimallChoice.vue'
import { trackFn, LazyQueue, getPromotionId, type ITrackConfig, tiktokTrack, getShowArrivalReminder } from '../mixins'
import { share } from '@/components/KSShareStore/share'
import SearchOperationContainer from '@/components/PC/HeaderBar/SearchOperationContainer.vue'
import { customEventFn, eventName, webClickFn } from '@/plugins/bi-sa.client'
import { config as sensorsConfig } from '@/plugins/sensors.client'
import { setUrlCache } from '~/api/models/system'
import { getPreviousPageKey, getTrafficSourceParts } from '@/utils/traffic-source'

interface IProps {
  detail: ProductV3.ListingDetailV3
  currentSkuId: number
  quantity: number
  inventoryStatus?: InventoryStatus
  
  promotionInfo: ProductV2.IPromotion

  skus: ProductV3.Sku[]
  currentSelectedSku?: ProductV3.Sku

  skuPrice: ProductV2.ISkuPrice
  gifts: IGifts[]
  deliveryInfo?: ProductV3.ShippingTime

  store?: Store.IStore
  hasSelectedAddress: boolean
  addressId?: number,
  // 评论数据
  reviewScore?: string
  reviewTotal?: number
  skuActivateInfo?: ProductV3.SelectedSkuActivity
  trackBaseData: ITrackConfig,

  // shippingTimeDescription: string
}
interface IEmits {
  (event: 'update:sku', skuKey: string, sku?: ProductV3.Sku): void
  (event: 'update:visble', visble: boolean): void
  (event: 'add-cart:success'): void
  (event: 'update:collect', e: boolean): void
  (event: 'delivery:warehouse', data: any): void
  (event: 'activity:over', activity: ProductV3.SelectedSkuActivity): void
  (event: 'retry:inventory'): void
  (event: 'switch:review'): void
  (event: 'update:quantity', val: number): void
  (event: 'arrival-reminder', state: boolean): void
}
const props = withDefaults(
  defineProps<IProps>(),
  {
    reviewScore: '5.0',
    reviewTotal: 0
  }
)
const emits = defineEmits<IEmits>()
const router = useRouter()
const route = useRoute()
const queue = new LazyQueue()
const { $SENSORS_EVENT,$sensors, $setShoppingCartLaconicList, $getCountry, $getListingDetailHref } = useNuxtApp()

const showKilimallChoice = computed(() => {
  return Array.isArray(props.detail.highlights)
    && props.detail.highlights.some(item => item.includes('Choice'))
})

const showSizePictureVisible = ref<boolean>(false)
const scaleSizePicture = ref<number>(1)
const handleSizeGuideClick = (sizeChartPicture: string) => {
  showSizePictureVisible.value = true
}
const handleWheelChange = (e: WheelEvent) => {
  const _scale =  e.deltaY > 0 ? -0.2 : 0.2

  if(scaleSizePicture.value >= 0.4 || _scale > 0) {
    scaleSizePicture.value += _scale
  }
}
const supportedServices = computed<string[]>(() => {
  const logisticsType = props.deliveryInfo?.logisticsType
  const tips: string[] = []

  if(!logisticsType) {
    return tips
  }

  logisticsType === 'fbk' && tips.push('Fulfilled By Kilimall')
  logisticsType === 'gs' && tips.push('Oversea Shipment')
  logisticsType === 'ds' && tips.push('Local Dispatch')

  return tips
})

const maxQuantity = computed<number>(() => {
  if(!props.currentSelectedSku) {
    return 0
  }

  const { fbkAvailable, dsAvailable, gsAvailable, fbkInventories } = props.currentSelectedSku.inventory

  if(fbkAvailable > 0) {
    return Math.max(...fbkInventories.map(c => c.available))
  }

  return Math.max(dsAvailable, gsAvailable)
})

const warningTipsText = computed<string[]>(() => {
  const { store, currentSelectedSku } = props
  const tips: string[] = []
  if(!store || !currentSelectedSku) {
    return tips
  }
  
  if (store?.status !== 1) {
    // 店铺状态 === 2时， 如果商品是FBK则可继续购买
    if(store?.status === 2) {
      if(props.deliveryInfo?.logisticsType !== 'fbk') {
        tips.push('Tips: Sorry this store is closed temporarily for vacation')
      }
    } else {
      tips.push('Tips: Sorry this store is closed temporarily for vacation')
    }
  }

  // if (!currentSelectedSku?.postageConfigured) {
  //   tips.push('Tips: This product didn\'t set delivery charge that you can not purchase.')
  // }
  const { gsAvailable, dsAvailable, fbkAvailable } = currentSelectedSku.inventory
  
  if (Math.max(gsAvailable, dsAvailable, fbkAvailable) <= 0 || currentSelectedSku?.status < 0) {
    tips.push('Sorry, the item is out of stock')
  }
  // if (currentSelectedSku.inventory > 0 && quantity.value > currentSelectedSku.inventory) {
  //   tips.push('Amount can\'t be more than stock')
  // }

  return tips
})

// const quantity = ref<number>(1)
const handleQuantityChange = (val: number) => {
  if (val !== props.quantity) emits('update:quantity', val)
}
// Intercept raw flash-sale input before Vant stores an out-of-range value.
const handleBeforeQuantityChange = (val: number | string) => {
  if (props.skuActivateInfo?.activityType !== 1) return true
  const value = Number(val)
  const quantity = Math.max(1, Math.min(Number.isFinite(value) ? value : 1, stepperMaxVal.value ?? Infinity))
  if (val !== '' && value === quantity) return true
  handleQuantityChange(quantity)
  if (value > quantity) handleQuantityOverlimit('plus')
  return false
}
const handleQuantityOverlimit = (type: string) => {
  if (type === 'plus' && props.skuActivateInfo?.activityType === 1) {
    showToast(`You can only place a maximum of ${Math.max(1, stepperMaxVal.value ?? 1)} flash sales item per order.`)
  }
}
const inWishList = ref<boolean>(false)
const specSelectIndexs = ref<string[]>([])
const initSpecSelectIndexs = (specs: ProductV2.ISpecs[]) => { 
  if(specs.length <= 0) { return }
  specSelectIndexs.value.length < specs.length && (specSelectIndexs.value = new Array(specs.length).fill(''))

  if(props.currentSelectedSku) {
    const { key } = props.currentSelectedSku
    const specAry = key.split(';')
    specAry.forEach((spec: string, idx: number) => {
      const [specBase, specVal] = spec.split(':')

      const baseIdx = specs.findIndex((c) => c.pid === Number(specBase))

      if(baseIdx >= 0) {
        const valIdx = specs[baseIdx].values.findIndex((c) => c.pvid === Number(specVal))

        specSelectIndexs.value[baseIdx] = `${baseIdx}_${valIdx}`
      }
    })
  } else {
    specSelectIndexs.value = new Array(specs.length).fill('').map((v: any, idx: number) => `${idx}_0`)
  }
}
watch(() => props.detail.specs, initSpecSelectIndexs)

const gensVoucherList: Ref<Array<Voucher>> = ref([])
watchEffect(
  () => {
    if(props.detail.vouchersInfo) {
      if(props.skuActivateInfo?.flashSale?.noVoucher) {
        gensVoucherList.value = []  
      } else {
        const { earnedVouchers, gens } = props.detail.vouchersInfo
        gensVoucherList.value = gens || []
      }
    }
  }
)
const getVoucherFn = async () => {
  if(props.skuActivateInfo?.flashSale?.noVoucher) {
    return console.info('该秒杀商品不支持优惠券')
  }
  const skuIds: number[] = props.skus.map((c: any) => c.skuId).slice(0, 20)
  const categoryId = props.detail.categoriesPath[props.detail.categoriesPath.length - 1].id
  const params: IVoucherParmas = {
    skuIds: skuIds,
    categoryId: categoryId,
    storeId: props.detail.storeId,
    listingId: props.detail.listingId
  }

  const voucherResult = await getVouchersBySkuids(params)
  // 未领取的优惠券
  if (voucherResult.gens && voucherResult.gens.length) {
    gensVoucherList.value = voucherResult.gens
  } else {
    gensVoucherList.value = []
  }
  // 已领取的优惠券
  if (voucherResult.earnedVouchers && voucherResult.earnedVouchers.length) {
    voucherResult.earnedVouchers.forEach((item: any) => {
      item.isEarned = true
    })
  }
}
onMounted(() => {
  if(!props.detail.listingId) {
    return
  }
  initSpecSelectIndexs(props.detail.specs)
  inWishList.value = props.detail.beenFollowed
  // getVoucherFn()
})
const handleSkuBtnClick = (index: number, idx: number) => {
  specSelectIndexs.value[index] = `${index}_${idx}`

  const skuKeys: string[] = []
  specSelectIndexs.value.forEach((c: string) => {
    const [baseIdx, valIdx] = c.split('_').map((c: string) => Number(c))

    const spec = props.detail.specs[baseIdx]
    const specValue = spec.values[valIdx]
    skuKeys.push(`${spec.pid}:${specValue.pvid}`)
  })
  
  const sku = props.skus.find((c: ProductV3.Sku) => {
    let inSku = true
    for(let i=0; i < skuKeys.length; i++) {
      inSku = c.key.indexOf(skuKeys[i]) >= 0

      if(!inSku) { break }
    }

    return inSku
  })

  emits('update:sku',skuKeys.join(';') || '', sku)
  // 切换sku增加BI商品浏览埋点
  if (sku) {
    const { source = '' } = route.query || {}
    const [
      internalLatestTrafficSourceModule = '',
      internalLatestTrafficSourceType = '',
      insideLatestTrafficSourceValue = '',
      internalFirstTrafficSourcePage = '',
      internalLatestTrafficSourcePage = ''
    ] = getTrafficSourceParts(source as string, props.trackBaseData.trafficSourceMeta)
    
    const { categoriesPath, listingId, title } = props.detail

    const categoryId = categoriesPath[categoriesPath.length - 1]?.id
    const biEventData = {
      internal_latest_traffic_source_module: internalLatestTrafficSourceModule,
      internal_latest_traffic_source_type: internalLatestTrafficSourceType,
      inside_latest_traffic_source_value: insideLatestTrafficSourceValue,
      internal_first_traffic_source_page: internalFirstTrafficSourcePage,
      internal_latest_traffic_source_page: internalLatestTrafficSourcePage,
      listing_id: listingId,
      sku_id: sku.skuId,
      category_id: categoryId,
      store_id: props.store?.id,
      isAd: props.trackBaseData.isAd,
      is_new_tag: !!props.trackBaseData.isNewTag,
      is_choice_tag: !!props.trackBaseData.isChoiceTag,
      request_id: props.trackBaseData.requestId || '',
      algorithm_model_name: props.trackBaseData.algorithmModelName || '',
      product_title: title,
      product_price: props.skuPrice.salePrice,
      product_inventory_type: props.deliveryInfo?.logisticsType?.toUpperCase(),
      sensor_properties: { ...props.trackBaseData }
    }
    const biProperties = {
      sensor_properties: { ...sensorsConfig.customEventCommonAttr }
    }
    
    customEventFn(eventName.viewProductDetail, biEventData, biProperties)
  }
}

const handleWishClick = async() => {
  const source = props.trackBaseData.source || (route.query.source as string) || ''
  const [
    internalLatestTrafficSourceModule = '',
    internalLatestTrafficSourceType = '',
    insideLatestTrafficSourceValue = '',
    firstPageFromSource = ''
  ] = getTrafficSourceParts(source, props.trackBaseData.trafficSourceMeta)
  // 收藏发生在商详：latest 用当前页；first 取链路 firstPage，空则兜底上一页
  const internalFirstTrafficSourcePage = firstPageFromSource || getPreviousPageKey() || ''
  const internalLatestTrafficSourcePage = 'productDetail'
  const isAd = props.trackBaseData.isAd || false
  const isNewTag = !!props.trackBaseData.isNewTag
  const isChoiceTag = !!props.trackBaseData.isChoiceTag
  const requestId = props.trackBaseData.requestId || ''
  if(inWishList.value) {
    await delWishListing(
      props.detail.listingId,
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      isAd,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage
    ).then(
      () => { inWishList.value = false}
    )
  } else {
    await wishListing(
      props.detail.listingId,
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      isAd,
      isNewTag,
      requestId,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage,
      isChoiceTag
    ).then(() => {
      showToast('Successfully added to wishlist.')
      inWishList.value = true
    })
    
    /** 埋点 */
    queue.addTask(() => { trackFn(props.trackBaseData, $SENSORS_EVENT.addToFavorites)})
    
    queue.addTask(() => {
      tiktokTrack(
        'AddToWishlist',
        1,
        props.currentSelectedSku,
        props.detail
      )
    })
  }
}

const stepperMaxVal = computed<number | undefined>(() => {
  const { skuActivateInfo } = props

  const defaultLimitNum = $getCountry()?.orderConfig?.qtyLimit || 30

  // 秒杀只能 加购/购买 限定数量的商品
  if(skuActivateInfo?.activityType === 1) {
    const limitNum = skuActivateInfo.flashSale?.limitNum

    // Preserve the existing explicit zero limit; negative limits use the country cap.
    if (limitNum === 0) return 0
    const inventory = skuActivateInfo.flashSale?.inventory
    const maxStock = inventory && inventory.fbkAvailable > 0
      ? Math.max(0, ...(inventory.fbkInventories || []).filter(item => item.warehouseId).map(item => item.available))
      : Math.max(0, inventory?.gsWarehouseId ? inventory.gsAvailable : 0, inventory?.dsWarehouseId ? inventory.dsAvailable : 0)
    const activityLimit = limitNum && limitNum > 0 ? limitNum : defaultLimitNum
    // Sold-out flash sales still need a positive quantity for the original-price entry.
    return Math.max(1, Math.min(activityLimit, defaultLimitNum, maxStock))
  } else {
    // 普通商品默认最多购买和加购 配置的最大可购买数量的 商品
    return maxQuantity.value > defaultLimitNum ? defaultLimitNum : maxQuantity.value
  }
})

const actions = computed(() => purchaseActions({
  sku: props.currentSelectedSku, activity: props.skuActivateInfo, store: props.store,
  quantity: props.quantity, inventoryStatus: props.inventoryStatus, platform: 'pc', allowOriginalPrice: true
}))
const buyNowStatus = computed(() => {
  const action = actions.value
  const original = action.buy === 'original-price'
  const target = original && props.currentSelectedSku ? preserveOriginalAttribution($getListingDetailHref(
    props.currentSelectedSku.skuId,
    { type: 'sku', title: String(props.detail.title || ''), shortTitle: props.detail.shortTitle || '', source: String(props.trackBaseData.source || '') },
    { writeCache: false }
  ), route.query) : undefined
  return {
    btnText: action.reason === 'loading' ? 'Loading...' : original ? 'Buy at Original Price' : action.buy === 'blocked' ? 'Unavailable' : 'Buy Now',
    btnTips: original ? 'This flash sales product is out of stock right now.' : '',
    disabledAddcart: !action.cart, disabledBuynow: action.buy === 'blocked',
    normalListingHref: target?.url || '', normalListingCacheKey: target?.key || '', normalListingCookie: target?.cookie
  }
})
// 订阅到货通知按钮显示
const showArrivalReminderBtn = computed(() => {
  const { currentSelectedSku, skuActivateInfo, store } = props
  
  return getShowArrivalReminder(currentSelectedSku, skuActivateInfo, store)
})

const handleCountdownOver = (activity: ProductV3.SelectedSkuActivity) => {
  emits('activity:over', activity)
}

/** 添加购物车 */
const handleAddCartClick = async() => {
  if(buyNowStatus.value.disabledAddcart) {
    return
  }

  try {
    const { articleId, authorCode, referCode } = route.query || {}
    const source = props.trackBaseData.source || ''
    const [
      internalLatestTrafficSourceModule = '',
      internalLatestTrafficSourceType = '',
      insideLatestTrafficSourceValue = '',
      internalFirstTrafficSourcePage = '',
      internalLatestTrafficSourcePage = ''
    ] = getTrafficSourceParts(source, props.trackBaseData.trafficSourceMeta)
    const isAd = props.trackBaseData.isAd || false
    const isNewTag = !!props.trackBaseData.isNewTag
    const isChoiceTag = !!props.trackBaseData.isChoiceTag
    const requestId = props.trackBaseData.requestId || ''
    const algorithmModelName = props.trackBaseData.algorithmModelName || ''
    const skuParams: ISkuItemParams = {
      sku: props.currentSkuId,
      count: props.quantity,
      activityId: 0,
      activityType: 0,
      referCode,
      authorCode,
      referSource: 'Listing',
      referSourceId: articleId,
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage,
      isAd,
      isNewTag,
      isChoiceTag,
      requestId,
      algorithmModelName
    }

    const addCartRes = await addCartItem(skuParams)
    if (addCartRes.code === 0) {
      showToast('Successfully added to shopping cart.')
      // BI埋点
      webClickFn(1, 'Add to Cart', true)
    } else {
      // BI埋点
      webClickFn(1, 'Add to Cart', false, 'api_code_error', addCartRes.msg || addCartRes.message)
    }
    

    const { imageUrls, listingId, title } = props.detail
    $setShoppingCartLaconicList({ 
      listingId: listingId,
      skuId: props.currentSkuId || -1,
      productImage: imageUrls[0] || '',
      productTitle: title,
      spec: props?.currentSelectedSku?.spec || '',
      salePrice: props.skuPrice.salePrice
    })

    getShipingCartTotal().then((r: any) => useShopingCartTotal().value = r?.count || 0)

    /** 埋点 */
    queue.addTask(() => { trackFn(props.trackBaseData, $SENSORS_EVENT.addToCart) })
    queue.addTask(() => {
      tiktokTrack(
        'AddToCart',
        props.quantity,
        props.currentSelectedSku,
        props.detail
      )
    })
  } catch (e) {
    console.error(e)
  }
}

// 到货通知订阅
const handleArrivalReminderClick = async() => {
  if(!props.currentSelectedSku) {
    return
  }

  const { isArrivalReminder, skuId } = props.currentSelectedSku
  try {
    await showConfirmDialog({
      message: isArrivalReminder 
        ? 'Do you want to cancel your subscription?'
        : 'Do you want to confirm that "Arrival Reminder" is enabled? Enable this function to receive alert when your desired products are restocked.',
    })
  } catch(e) {
    return
  }
  
  const params: ISubscriptionParams = {
    source_type: 3,
    is_subscribe: !isArrivalReminder,
    sku_id: skuId
  }

  try {
    await putSubscription(params)
    showToast('Notification set successfully!')

    emits('arrival-reminder', params.is_subscribe)
  } catch(e: any) {
    console.error(e)
    if(e.code !== 1001 && e.msg) {
      showToast(e.msg)
    }
  }
}

const handleSwitchReviewTabClick = () => {
  emits('switch:review')
}

const handleByNowClick = async() => {
  const {
    currentSkuId, skuActivateInfo, store, skuPrice, promotionInfo
  } = props
  
  if(buyNowStatus.value.disabledBuynow) {
    $sensors.track(
      $SENSORS_EVENT.clickOrderNow,
      { verificationStatus: false, failureType: store?.status !== 1 ? 'Store' : 'Product', failureReason: warningTipsText.value.join(',') }
    )
    webClickFn(2, 'Buy Now', false, store?.status !== 1 ? 'Store' : 'Product', warningTipsText.value.join(','))
    return
  }

  if(!useUserInfo().value?.accessToken) {
    $sensors.track($SENSORS_EVENT.clickOrderNow, { verificationStatus: false, failureType: 'NotLogin', failureReason: 'Not Login.' })
    router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
    webClickFn(2, 'Buy Now', false, 'page_check', 'Not Login.')
    return
  }
  if(!currentSkuId) {
    $sensors.track($SENSORS_EVENT.clickOrderNow, { verificationStatus: false, failureType: 'Product', failureReason: 'Please choose a specification.' })
    webClickFn(2, 'Buy Now', false, 'page_check', 'Please choose a specification.')
    return showToast('Please choose a specification.')
  }

  if(buyNowStatus.value.normalListingHref) {
    const { normalListingHref, normalListingCacheKey, normalListingCookie } = buyNowStatus.value
    if (normalListingCookie && normalListingCacheKey) {
      setUrlCache(normalListingCookie, normalListingCacheKey).catch((e) => {
        console.error('setUrlCache failed:', e)
      })
    }
    window.open(normalListingHref)

    return
  }

  const { authorCode, referCode } = route.query || {}
  const source = props.trackBaseData.source || ''
  const [
    internalLatestTrafficSourceModule = '',
    internalLatestTrafficSourceType = '',
    insideLatestTrafficSourceValue = '',
    internalFirstTrafficSourcePage = '',
    internalLatestTrafficSourcePage = ''
  ] = getTrafficSourceParts(source, props.trackBaseData.trafficSourceMeta)
  const promotionId = getPromotionId(skuActivateInfo?.activityPrice || skuPrice.salePrice, props.quantity, promotionInfo.bigPromotion)

  const activateParams: IAnyObject = { activityId: 0, activityType: 0 }

  // 只有秒杀商品才需要传入 活动ID 和 Type
  if(skuActivateInfo?.activityType === 1) {
    activateParams.activityId = skuActivateInfo?.activityId,
    activateParams.activityType = skuActivateInfo?.activityType
  }

  const byNow: Order.ICheckoutParam = {
    product: [{
      /** 埋点数据 */
      internalLatestTrafficSourceModule,
      internalLatestTrafficSourceType,
      insideLatestTrafficSourceValue,
      internalFirstTrafficSourcePage,
      internalLatestTrafficSourcePage,
      ...props.trackBaseData,
      /** 埋点数据 */
      promotionId: promotionId !== -1 ? promotionId : undefined,
      skuId: props.currentSkuId,
      count: props.quantity,
      // 外部分享，Prefee 老逻辑
      authorCode,
      referCode,
      // 活动 SKU 下单参数
      ...activateParams
    }],
    addressId: props.addressId,
    source: 2
  }

  localStorage.setItem('ck_pms', JSON.stringify(byNow))

  webClickFn(2, 'Buy Now', true)

  const categoryId = props.detail.categoriesPath[props.detail.categoriesPath.length - 1]?.id

  window.open(router.resolve(`/checkout?categoryId=${categoryId}`).href)
}

const handleFreeShippingPromotionClick = (shipPromotion: ProductV2.IFreeShippingPromotion) => {
  showDialog({ title: 'Free Shipping', message: shipPromotion.copyWriting, messageAlign: 'left', width: '600px' });
}
const handleBigPromotionClick = (item: ProductV2.IBigPromotion) => {
  const href = useRouter().resolve({
    path: `/promotion-listings/${item.rule.discount}-${item.rule.priceBreak}-${item.name}-${item.id}`,
    query: { first_page: 'productDetail' }
  }).href
  
  window.open(href)
}

const sharePopupShow = ref<boolean>(false)
const shareLinkTypeData = ref<any>({})      
const handleShareClick = async () => {
  const { listingId } = props.detail
  const params: IShareLinkType = {
    sourceType: 'Listing',
    sourceId: listingId,
    generateShortLink: false,
    ...buildShareLinkTrafficSourceParams('Listing')
  }
  const shareTypeRes = shareLinkTypeData.value = await getShareLink(params)
  if (shareTypeRes.code === 0) {
    sharePopupShow.value = true
    webClickFn(3, 'shareIcon', true)
  } else {
    webClickFn(3, 'shareIcon', false, 'api_code_error', shareTypeRes.msg || shareTypeRes.message)
    showToast(shareTypeRes.msg || shareTypeRes.message)
  }
  customEventFn(eventName.clickToShareButton, {
    share_type: 'shareProduct'
  })

}
const handleShareItemClick = (e: any) => {
  let url = `${useCurrentHost()}/listing/${props.detail.listingId}?source=productDetails-share`
  if (shareLinkTypeData.value.code === 0) {
    // 取接口短链
    const shareLinkTypeList = shareLinkTypeData.value?.data?.templates || []
    shareLinkTypeList.forEach((item: any) => {
      if (e.key === 'Facebook' && item.channel === 'facebook' && item.code === 'link') {
        url = item.textEn
      }
      else if (e.key === 'WhatsApp' && item.channel === 'whatsapp' && item.code === 'link') {
        url = item.textEn
      }
      else if ((e.key === 'SMS' || e.key === 'CopyLink') && item.channel === '' && item.code === 'link') {
        url = item.textEn
      }
    })
  }
  share(
    e,
    { 
      href: url,
      title: '🌟 Check out this amazing product! 😍 Click the link and see why everyone’s raving about it! 🚀🛒',
      shareContents: props.detail.title
    },
    'shareProduct'
  )

  $sensors.track(
    $SENSORS_EVENT.clickToShareButton,
    { 
      shareType: 'shareProduct'
    }
  )
}


</script>

<style lang="scss" scoped>
.size-chart-picture{
  width: 1400px;
  height: 1400px;
  padding: 30px;
  @include center();
  overflow: hidden;
  img{
    transition: all .15s;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.sku-wrapper{
  display: flex;
  padding: 30px;
  background-color: #fff;
  .image-box{
    width: 900px;
    min-width: 900px;
  }
  .content-box{
    flex: 1;
    padding-left: 30px;
    max-width: calc(var(--viewport-width) - 900px - 60px);
    .product-title{
      font-size: 42px;
      line-height: 52px;
      color: #333;
      font-weight: 500;
      @include ellipsisMultiline(3);
    }

    .score-and-reviews{
      margin: 30px 0 20px 0;
      display: flex;
      align-items: center;
      font-size: 28px;
      span{
        display: inline-block;
      }
      .rate{
        margin-left: 20px;
        color: var(--pc-default-color);
        margin-right: 60px;
      }
      .reviews{
        color: #409eff;
        cursor: pointer;
      }
    }

    .product-price{
      background-color: #f5f7fa;
      padding: 30px 20px;
      display: flex;
      align-items: flex-end;
      .sale-price{
        font-weight: 600;
        color: var(--pc-default-color);
        font-size: 48px;
      }
      .del-price{
        font-size: 30px;
        color: #999;
        text-decoration: line-through;
        margin: 0 30px;
      }
      .discount{
        display: inline-block;
        color: var(--pc-default-color);
        margin-left: 10px;
      }
    }

    .buyer-infos{
      border-top: 1px solid #efefef;
      margin-top: 30px;
      padding: 30px 0 20px 0;      
      .loading-box{
        height: 260px;
        background-color: rgba($color: #fff, $alpha: 0.4);
        width: 100%;
        @include center();
      }
      .info-item-spec{
        line-height: 96px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .size-guide{ color: #3b9dff;font-weight: 400;cursor: pointer; }
      }
      .info-item-gift{
        line-height: 54px;
      }
      
      .info-item{
        display: flex;
        align-items: flex-start;
        margin-bottom: 30px;
        min-height: 70px;
        .label{
          min-width: 360px;
          white-space: nowrap;
          margin-right: 20px;
        }
        .services-item{
          margin-right: 40px;
          color: #666;
          i{
            margin-right: 10px;
          }
        }
        .link-value{
          color: #409eff;
          cursor: pointer;
        }
        .info-item-center{
          align-items: center;
        }
        .info-item:deep(.delivery-content) {
          margin-top: 0;
        }
        .info-item:deep(.gift-item){
          cursor: pointer;
          .gift-title{
            border-bottom: 1px solid #666;
          }
        }
      }
      .info-item-center{
        align-items: center;
      }
      .info-item:deep(.delivery-content) {
        margin-top: 0;
      }
      .info-item:deep(.gift-item){
        cursor: pointer;
        .gift-title{
          border-bottom: 1px solid #666;
        }
      }
    }
  }
}

.warning-tips {
  padding-top: 26px;
  color: #999;
  font-size: 24px;
}

.btn-tips{
  color:#f74711;
  i { font-size: 32px; }
}

.promotion-item{
  display: inline-block;
  padding: 10px 20px;
  margin: 10px 10px 0 0;
  cursor: pointer;
  color: var(--pc-default-color);
  background-color: rgba($color: #DD3131, $alpha: 0.08);
  border-radius: 6px;
}
.payment-icon{
  margin-right: 20px;
  height: 76px;
}
.spec-btn-box{
  position: relative;
  margin: 5px;
  display: inline-block;
  .sku-btn {
    background-color: #fff;
    border: 1px solid #dcdcdc;
    border-radius: 12px;
    padding: 0 10px;
    font-size: 28px;
    min-width: 140px;
    cursor: pointer;
    height: 80px;
    display: flex;
    align-items: center;
    .sku-img-box{
      height: 60px;
      margin-right: 10px;
    }
    .sku-img{
      width: 60px;
      height: 100%;
      object-fit: contain;
    }
  }
  .sku-btn[select="1"]{
    border-color: var(--pc-default-color);
    color: var(--pc-default-color);
    background: rgba(255, 0, 95, 0.05);
  }
  .sold-out-mark{
    position: absolute;
    top: -10px;
    right: 0;
    background-color: #cacaca;
    color: #fff;
    border-radius: 25px;
    line-height: 25px;
    padding: 0 8px;
    font-size: 18px;
    overflow: hidden;
  }
}

.opt-btn{
  width: 380px;
  font-size: 34px;
  text-shadow: 0 0 2px #fff;
}
.collect-btn{
  margin-left: 30px;
}
.yellow-btn{
  color: #fff;
  margin-right: 30px;
  background: linear-gradient(90deg,#ffbb01,#ff6247 100%,#ff6047 0);
}
.disabled-opt-btn {
  opacity: .8 !important;
  background: #666 !important;
  color: #fff;
  cursor: not-allowed;
  border-color: #666;
}
.prepaid-tips{
  color: var(--pc-default-color);
  font-size: 24px;
  margin-top: 20px;
}

.share-title{
  color: #333;
  font-weight: 600;
  font-size: 36px;
  text-align: center;
  padding: 30px 0;
}
.share-product-card{
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
  padding: 20px;
  margin: 0 30px;
  border-radius: 10px;
  overflow: hidden;
  width: 1000px;
  .product-image{
    width: 120px;
    border-radius: 10px;
    min-width: 120px;
    height: 120px;
    margin-right: 20px;
    object-fit: contain;
    background-color: #fff;
  }
  .product-name{
    flex: 1;
    @include ellipsisMultiline(2);
    font-size: 26px;
    line-height: 40px;
    color: #333;
  }
}
.voucher-div {
  width: 100%;
  display: flex;
  .voucher-item {
    min-width: 140px;
    height: 52px;
    line-height: 52px;
    background-color: #CC413A;
    color: white;
    text-align: center;
    margin: auto;
    -webkit-mask: radial-gradient(circle at 4px, transparent 4px, #CC413A 0) -4px / 100% 15px;
    margin-right: 20px;
    cursor: pointer;
  }
  .claim-now {
    color: #999999;
    font-size: 28px;
    margin-left: 20px;
    height: 52px;
    line-height: 52px;
  }
}
.voucher-prop-div {
  background-color: white;
  width: 900px;
  min-height: 300px;
  max-height: 920px;
  overflow-y: auto;
}
</style>
